import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Breadcrumbs,
  BreadcrumbItem,
  Chip,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleRight, faArrowLeft, faArrowRightFromBracket, faArrowsToDot, faChevronLeft, faChevronRight, faFileCircleCheck, faRotateForward, faSquareXmark } from "@fortawesome/free-solid-svg-icons"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css
import { jwtDecode } from "jwt-decode"
import { useDispatch, useSelector } from "react-redux"
import { setTokenExpiry } from "../state/authSlice"
import { isMobile } from "react-device-detect"

export default function MainContainer({
  children,
  info = [],
  pageName = "",
  breadcrumbs = [],
  prevPage = {},
}) {
  const [expiryTime, setExpiryTime] = useState(null);

  const { token } = useSelector((state) => state.auth)
  const dispatch = useDispatch();

  useEffect(() => {

    if (token && token != "") {

      const decoded = jwtDecode(token);

      // Extract the expiration time and convert it to a human-readable format
      const expirationTime = new Date(decoded.exp * 1000); // Convert from seconds to milliseconds

      let hours = expirationTime.getHours();
      const minutes = expirationTime.getMinutes();
      const seconds = expirationTime.getSeconds();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      // Convert 24-hour format to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 becomes 12 (for midnight)

      // Format minutes and seconds to always show two digits
      const formattedTime = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} `;

      setExpiryTime(formattedTime + " " + ampm); // Show in a readable format

      dispatch(setTokenExpiry(expirationTime.getTime() / 1000))
    }
  }, []);

  return (
    <div radius="none" className={`${isMobile ? "m-2" : ""} " border-0 rounded-none lg:ml-64 lg:pr-5 z-1"`}>
      {/* lg:ml-64 */}
    
      <div className="flex p-1 w-full flex-col gap-1 
      border-0 
       items-start sticky align-top">
        <div className="flex items-center justify-between w-full  ">

          <div className="flex items-center justify-start ">

            {/* breadcrumbs */}
            {breadcrumbs?.length > 0 && (
              <Breadcrumbs  size="sm" variant="light" className="text-xs">

                {breadcrumbs?.map((item) => {
                  return (
                    <BreadcrumbItem className="text-xs text-white" key={item}>
                      {item}
                    </BreadcrumbItem>
                  )
                })}
              </Breadcrumbs>
            )}
            {/* end of breadcrumbs */}

          </div>
          <div className=" text-xs font-semibold bg-h-100 text-slate-700">
            {"session expire at :" + expiryTime}
          </div>
        </div>
        <div className="w-full">
        <Card radius="sm" className="shadow-xl" >
          <CardBody className="p-0">
        
          {/* page heading */}
          <div className="flex items-centerjustify-end w-full mb-0  shadow">
            {pageName && pageName != "" ?
              <div color="primary" radius="sm" className="w-full   py-0
             uppercase ml-0" ><div className="  text-red-600 font-bold flex items-center gap-2" >
                  <div className=" text-xs  bg-gradient-to-b from-slate-700 to-slate-900 border-0  ">
                    <FontAwesomeIcon className="text-white p-2  font-semibold " icon={faArrowRightFromBracket} ></FontAwesomeIcon>
                  </div>
                 <span  style={{fontSize:"0.7rem"}} >{pageName}</span>  </div> </div> : ""}

            {prevPage && prevPage?.show && (
              <Chip
                size="md"
                color="success"
                variant="flat"
                className=" p-2 cursor-pointer bg-gradient-to-t from-lime-800 to-lime-400 text-white"
                radius="sm"
                startContent={<FontAwesomeIcon icon={faArrowLeft} />}
                onClick={prevPage?.onClick}
              >
                BACK
              </Chip>
            )}
          </div>
          <div className=" flex  flex-wrap text-gray-500 text-xs font-semibold">
            {info.map((infoItem, index) => {
              return (
                <div>
                  <FontAwesomeIcon icon={faChevronRight}></FontAwesomeIcon>
                  <Chip key={index} variant="light"
                    color="danger" className="text-xs">
                    {infoItem.map((item, index) =>
                      //return (

                      item + " "

                      // )

                    )}
                  </Chip>
                </div>
              )
            })}
          </div>
          {/* end of page heading */}
        
        </CardBody>            
        </Card>
        </div>
      </div>
      <div>{children}</div>
      <div></div>
    </div>
  )
}
